import Load from 'components/Load';
import React from 'react';
import { Navigate, Route } from 'react-router-dom';
import basePath from 'utils/basePath';

const AsyncAuthContainer = Load(
  () =>
    import(
      /* webpackChunkName: "auth-container" */ './containers/AuthContainer'
    ),
);
const AsyncCheckoutChildRoutes = Load(
  () => import(/* webpackChunkName: "checkout" */ './CheckoutChildRoutes'),
);

const CheckoutRoutes = [
  <Route
    key="checkout-root-redirect"
    path={`${basePath}/booking/`}
    element={<Navigate to={`${basePath}/booking/auth/`} replace />}
  />,
  <Route
    key="checkout-auth"
    path={`${basePath}/booking/auth/`}
    element={<AsyncAuthContainer />}
  />,
  <Route
    key="checkout"
    path={`${basePath}/booking/:tripId/*`}
    element={<AsyncCheckoutChildRoutes />}
  />,
];

export default CheckoutRoutes;
